import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";

const Contact: React.FC = () => {
  return (
    <section id="contact" className="mt-20 scroll-mt-28">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <motion.h2
          variants={itemUp}
          className="text-2xl font-semibold text-cyan-700"
        >
          Contact
        </motion.h2>
        <motion.p variants={itemUp} className="mt-4 text-gray-200">
          I'm currently available for new roles and contract work. Reach out at{" "}
          <a href={`mailto:ashanmsilva.cse@gmail.com`} className="underline">
            ashanmsilva.cse@gmail.com
          </a>
          .
        </motion.p>
      </motion.div>
    </section>
  );
};

export default Contact;
